<template>
  <div class="ba-w-100 ba-grid ba-gp-08">

    <div class="ba-grid ba-gp-08">
      <div class="ba-flex ba-jc-start">
        <builderall-icon code='arrow-left' class="ba-color-blue1" @click="$emit('setComponent', 'PaymentIntegrations')"
          style="cursor: pointer;"></builderall-icon>
      </div>
      <div class="ba-flex ba-jc-sb ba-ai-center">
        <span class="ba-montserrat-600 ba-text-14">{{ $t('ct-automatic-emails-integrations') }}</span>
        <div class="ba-flex ba-gp-08">
          <button type="button" @click.prevent="$refs.actionEmail.open()" class="ba-btn ba-md ba-blue"><builderall-icon
              code='2780'></builderall-icon>
            {{ $t('ct-email-new-theme') }}
          </button>
          <button type="button" @click.prevent="save()" class="ba-btn ba-md ba-blue">{{ $t('ct-save') }}
          </button>
        </div>
      </div>
      <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-automatic-emails-integrations-desc') }}</span>
    </div>

    <div v-if="website">
      <!-- <form action="/"> -->

        <div class="ba-w-100 ba-grid ba-gp-08">
          <div v-if="!(emails.themes.length > 0)" class="text-center">{{ $t('ct-automatic-emails-is-empty') }}</div>

          <div class="container-accordion-form" id="accordion-emails" v-for="(theme, indx) in emails.themes"
            v-if="emails.themes.length > 0" :key="indx">

            <div class="card">
              <div class="card-header ba-flex ba-jc-sb ba-ai-center" :class="{ 'collapsed': !theme.expanded }"
                data-toggle="collapse" :data-target="`#collapseEmailTheme${indx}`" :aria-expanded="theme.expanded"
                :aria-controls="`collapseEmailTheme${indx}`">
                <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                  {{ $t(theme.name) }}
                </span>
                <div class="ba-flex ba-gp-06">
                  <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.stop="editEmailTheme(theme)">
                    <builderall-icon code='edit' />
                  </button>
                  <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.stop="deleteEmailTheme(indx)">
                    <builderall-icon code='trash' />
                  </button>
                  <span class="d-inline-block float-right">
                    <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                  </span>
                </div>
              </div>

              <!-- <div class="card-header" :id="`headingEmailTheme${indx}`">
                  <span class="py-1 d-inline-block collapsed" data-toggle="collapse"
                    :data-target="`#collapseEmailTheme${indx}`" aria-expanded="true"
                    :aria-controls="`collapseEmailTheme${indx}`">
                    {{ theme.name }}
                  </span>
                  <span class="d-inline-block float-right collapsed" data-toggle="collapse"
                    :data-target="`#collapseEmailTheme${indx}`" aria-expanded="true"
                    :aria-controls="`collapseEmailTheme${indx}`">
                    <font-awesome-icon :icon="['fas', 'sort-down']" class="font-awesome-icon" />
                  </span>

                  <button class="btn btn-danger float-right mx-1 px-3 mr-3" @click.prevent="deleteEmailTheme(indx)">
                    <i class="svg-icon svgi-delete svgi-light mx-0"></i>
                  </button>
                  <button class="btn btn-primary float-right mx-1" @click.prevent="editEmailTheme(theme)">
                    <i class="svg-icon svgi-edit svgi-light"></i>
                    {{ $t('ct-email-theme-edit') }}
                  </button>
                </div> -->
              <div :id="`collapseEmailTheme${indx}`" class="collapse" :aria-labelledby="`headingEmailTheme${indx}`" data-parent="#accordion-emails">
                <section class="card-body">
                  <div class="ba-w-100 ba-grid ba-gp-08">
                    <span class="ba-montserrat-700 ba-text-14">{{ $t('ct-automatic-emails-config-normal') }}</span>
                    <hr class="ba-hr-row">
                    <nav>
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link" :class="{'active' : index === 0 }"
                          :id="`nav-${getId(index,indx,config.type)}-tab`" data-toggle="tab"
                          :href="`#nav-${getId(index,indx,config.type)}`" role="tab"
                          :aria-controls="`nav-${getId(index,indx,config.type)}`" aria-selected="true"
                          v-for="(config, index) in getFilters(theme.configs, types_normal)">{{
                          $t(`ct-email-theme-${config.type.split('_').join('-')}`)
                          }}</a>
                      </div>
                    </nav>

                    <div class="tab-content" id="nav-tabContent">
                      <div class="tab-pane p-2" :class="{'active' : index === 0 }"
                        :id="`nav-${getId(index,indx,config.type)}`" role="tabpanel"
                        :aria-labelledby="`nav-${getId(index,indx,config.type)}-tab`"
                        v-for="(config, index) in getFilters(theme.configs, types_normal)">

                        <div class="ba-grid ba-w-100">
                          <label for="subject" class="ba-custom-label">{{ $t('ct-subject') }}</label>
                          <input type="text" class="ba-input ba-md" id="subject" v-model="config.subject">
                        </div>
                        <div class="ba-w-100 ba-pd-t-1">
                            <CKEditor v-model="config.content"
                              :id="`CKEditor-${indx}-${replaceId(config.type)}-${(theme.name.replace(' ', '-').replace(/[^\w\s]/gi, ''))}`"
                              :toolbar="CKEditor_config.toolbar" :fullPage="false" :height="CKEditor_config.height"
                              :tags="tags"></CKEditor>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="ba-w-100 ba-grid ba-gp-08">
                    <span class="ba-montserrat-700 ba-text-14">{{ $t('ct-automatic-emails-config-recurrence') }}</span>
                    <hr class="ba-hr-row">
                    <nav>
                      <div class="nav nav-tabs" id="nav-tab-recurrence" role="tablist">
                        <a class="nav-item nav-link" :class="{'active' : index === 0 }"
                          :id="`nav-${getId(index,indx,config.type)}-tab`" data-toggle="tab"
                          :href="`#nav-${getId(index,indx,config.type)}`" role="tab"
                          :aria-controls="`nav-${getId(index,indx,config.type)}`" aria-selected="true"
                          v-for="(config, index) in getFilters(theme.configs, types_recurrence)">{{
                          $t(`ct-email-theme-${config.type.split('_').join('-')}`)
                          }}</a>
                      </div>
                    </nav>

                    <div class="tab-content" id="nav-recurrence-tabContent">
                      <div class="tab-pane p-2" :class="{'active' : index === 0 }"
                        :id="`nav-${getId(index,indx,config.type)}`" role="tabpanel"
                        :aria-labelledby="`nav-${getId(index,indx,config.type)}-tab`"
                        v-for="(config, index) in getFilters(theme.configs, types_recurrence)">

                        <div class="ba-grid ba-w-100">
                          <label for="subject" class="ba-custom-label">{{ $t('ct-subject') }}</label>
                          <input type="text" class="ba-input ba-md" v-model="config.subject">
                        </div>
                        <div class="ba-w-100 ba-pd-t-1">
                            <CKEditor v-model="config.content"
                              :id="`CKEditor-${indx}-${replaceId(config.type)}-${(theme.name.replace(' ', '-').replace(/[^\w\s]/gi, ''))}`"
                              :toolbar="CKEditor_config.toolbar" :fullPage="false" :height="CKEditor_config.height"
                              :tags="tags"></CKEditor>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 col-lg-10 text-center">
            <button v-if="emails.themes.length > 0" type="submit" class="btn btn-y-lg btn-success"
              @click.prevent="save">
              <i class="svg-icon svgi-save"></i>
              {{ $t('ct-save') }}
            </button>
          </div> -->
        </div>
      <!-- </form> -->
    </div>

    <sweet-modal ref="actionEmail" width="60vw" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-email-theme-name') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closeActionEmail">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1">
        <div ref="form-email-action">
          <div class="ba-box-input">
            <label for="theme-email" class="ba-custom-label">{{ $t('ct-email-theme-name') }}</label>
            <input type="text" class="ba-input ba-md" id="theme-email" name="name" v-model="newTheme.name"
              required="required" @keydown="errors.clear('newTheme.name')"
              :class="{ 'is-invalid': errors.has('newTheme.name') }">
            <span v-if="errors.has('newTheme.name')" class="ba-validation-text"
              v-text="errors.get('newTheme.name')"></span>
          </div>
        </div>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="closeActionEmail">{{
          $t('ct-cancel') }}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="addEmailTheme">{{ $t('ct-save')
          }}</button>
      </div>

      <!-- <div ref="form-email-action">
        <div class="form-group">
          <label for="theme-email">{{ $t('ct-email-theme-name') }}</label>
          <input type="text" class="form-control" id="theme-email" name="name" v-model="newTheme.name"
            required="required" @keydown="errors.clear('newTheme.name')"
            :class="{ 'is-invalid': errors.has('newTheme.name')}">
          <span v-if="errors.has('newTheme.name')" class="invalid-feedback" v-text="errors.get('newTheme.name')"></span>
        </div>
      </div>

      <button slot="button" class="btn btn-default" @click="closeActionEmail">
        {{ $t('ct-cancel') }}
      </button>
      <button slot="button" class="btn btn-success" @click="addEmailTheme">
        <i class="svg-icon svgi-save"></i>
        {{ $t('ct-save') }}
      </button> -->
    </sweet-modal>
  </div>
</template>

<script>
import NavComponent from '../../layout/nav/Nav.vue';
import ModalDeleteComponent from './../../components/ModalDelete';
import SiteSidebarComponent from './../../layout/site/SiteSidebar';
import CKEditor from './../../components/CKEditor';
import {SweetModal} from 'sweet-modal-vue';
import Errors from '../../../../js/base/Errors';

import {edit, getAll} from './../../../../js/services/restrictArea/automaticEmails';

export default {
  name: 'EmailsIntegrations',
  components: {
    NavComponent,
    ModalDeleteComponent,
    SiteSidebarComponent,
    CKEditor,
    SweetModal
  },

  data() {
    return {
      errors: new Errors(),
      CKEditor_config: {
        height: '250',
        toolbar: [
          {
            name: 'document',
            groups: ['mode', 'document', 'doctools'],
            items: ['Source']
          },
          {
            name: 'clipboard',
            groups: ['clipboard', 'undo'],
            items: ['Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo']
          },

          {name: 'links', items: ['Link', 'Unlink']},

          {
            name: 'paragraph',
            groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
            items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
          },
          {name: 'colors', items: ['TextColor', 'BGColor']},
          {
            name: 'basicstyles',
            groups: ['basicstyles', 'cleanup'],
            items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat']
          },
          {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']}
        ]
      },
      tags: [
        {
          name: 'user-name',
          tag: '[USER_NAME]',
          label: 'user-name'
        },
        {
          name: 'user-email',
          tag: '[USER_EMAIL]',
          label: 'user-email'
        },
        {
          name: 'integration-code',
          tag: '[INTEGRATION_CODE]',
          label: 'integration-code'
        }
      ],
      website: {encrypted_id: ''},
      content: '',

      emails: {
        themes: []
      },

      types_normal: ['sale_completed', 'sale_canceled'],
      types_recurrence: ['sale_recurrence_completed', 'sale_recurrence_canceled'],

      newTheme: {
        action: 'create',
        name: '',
        configs: [
          {
            type: 'sale_completed',
            subject: this.$t('ct-integrations-subject-sale-completed'),
            content: this.getFormBaseSale('sale-completed'),
          },

          {
            type: 'sale_canceled',
            subject: this.$t('ct-integrations-subject-sale-canceled'),
            content: this.getFormBaseSale('sale-canceled')
          },

          {
            type: 'sale_recurrence_completed',
            subject: this.$t('ct-integrations-subject-sale-recurrence'),
            content: this.getFormBaseSale('sale-recurrence')
          },

          {
            type: 'sale_recurrence_canceled',
            subject: this.$t('ct-integrations-subject-recurrence-canceled'),
            content: this.getFormBaseSale('recurrence-cancel')
          }
        ]
      }
    };
  },

  methods: {
    replaceId(value) {
      return value.replace('_', '-').replace(' ', '-').replace(/[^\w\s]/gi, '');
    },

    getId(index, indx, type) {
      return `${index}${indx}-${type.replace('_', '-')}`
    },

    getFilters(configs, types) {
      return configs.filter(cg => types.includes(cg.type))
    },

    clearString(string) {
      return string.toUpperCase().trim();
    },

    validate() {
      return this.errors.any();
    },

    save() {
      let data = this.emails;
      data.website = this.website;

      if (!this.validate()) {
        this.$loading.show();

        edit(data, 'members_integrations_sale')
          .then(response => {
            if (response.data.success) {
              this.$snotify.success(this.$t('ct-saved-successfully'));
            } else this.$snotify.error(this.$t('ct-error-saving'));
          })
          .catch(() => {
            this.$snotify.error(this.$t('ct-error-saving'));
          })
          .finally(() => {
            this.$loading.hide();
            this.closeActionEmail();
          });
      }
    },

    addEmailTheme() {
      this.errors.validateFormat(
        this.$refs['form-email-action'],
        'newTheme'
      );

      var index = this.emails.themes.map(function (theme) {
        return theme.name;
      }).indexOf(this.newTheme.name);

      if (this.emails.themes.find((theme, i) => this.clearString(theme.name) === this.clearString(this.newTheme.name) && i !== index)) {
        this.errors.add('name', 'validation-already-been-taken', 'newTheme');
      }

      if (!this.validate()) {
        if (this.newTheme.action === 'create') {
          this.emails.themes.push(this.newTheme);
        }
        this.closeActionEmail();
      }
    },

    editEmailTheme(theme) {
      this.newTheme = theme;
      this.newTheme.action = 'update';

      this.$refs.actionEmail.open();
    },

    deleteEmailTheme(index) {
      this.emails.themes.splice(index, 1);
    },

    emptyNewTheme() {
      this.newTheme = {
        action: 'create',
        name: '',
        configs: [
          {
            type: 'sale_completed',
            subject: this.$t('ct-integrations-subject-sale-completed'),
            content: this.getFormBaseSale('sale-completed'),
          },

          {
            type: 'sale_canceled',
            subject: this.$t('ct-integrations-subject-sale-canceled'),
            content: this.getFormBaseSale('sale-canceled')
          },

          {
            type: 'sale_recurrence_completed',
            subject: this.$t('ct-integrations-subject-sale-recurrence'),
            content: this.getFormBaseSale('sale-recurrence-completed')
          },

          {
            type: 'sale_recurrence_canceled',
            subject: this.$t('ct-integrations-subject-sale-recurrence-canceled'),
            content: this.getFormBaseSale('recurrence-cancel')
          }
        ]
      };
    },

    closeActionEmail() {
      this.$refs.actionEmail.close();
      this.errors.clear();
      this.emptyNewTheme();
    },

    getFormBaseSale(type = '') {
      return `
        <table class="rtable mainTable" style="background:#E5F0F5;width:100%">
          <tbody>
          <tr>
            <td style="height:20px;"></td>
          </tr>
          <tr>
            <td>
              <table align="center" class="rtable"style="width:702px;margin:0 auto;">
                <tbody>
                <tr>
                  <td
                    style="border:#eae8e8 1px solid;padding:0;background-color:#feffff;">
                    <table class="rtable" style="width:100%;">
                      <tbody>
                      <tr style="">
                        <td
                          style="border-top:medium none;border-right:medium none;width:100%;vertical-align:top;border-bottom:medium none;text-align:center;padding:0 15px;border-left:medium none;background-color:#feffff;">
                          <p align="justify"
                             style="font-size:18px;margin-bottom:1em;font-family:Arial, Helvetica, sans-serif;margin-top:0;color:#a7a7a7;text-align:justify;line-height:155%;background-color:transparent;">
                            <span style="font-size: 14px; pointer-events: all;">${this.$t('ct-hello')} <span style="pointer-events: all;">[USER_NAME]</span>!</span>
                          </p>
                          <p
                            style="margin-bottom: 1em; font-family: Arial, Helvetica, sans-serif; margin-top: 0; line-height: 155%; background-color: transparent;">
                              <span style="font-size: 20px; pointer-events: all;">${this.$t(`ct-integrations-${type}-title`)}</span>
                          </p>
                          <p align="justify"
                             style="font-size: 12px; margin-bottom: 1em; font-family: Arial, Helvetica, sans-serif; margin-top: 0; text-align: justify; line-height: 155%; background-color: transparent;">
                             <span style="font-size: 14px; pointer-events: all;">
                               <span style="color: rgb(169, 169, 169); pointer-events: all;">${this.$t(`ct-integrations-${type}-description`)}</span>
                               <br/>
                               <br/>
                             </span>
                          </p>
                          <p style="color: rgb(169, 169, 169); pointer-events: all;text-align:center;font-size: 14px;font-family: Arial, Helvetica, sans-serif;">${this.$t(`ct-integrations-thanks-app`)}</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td style="height:8px;"></td>
          </tr>
          </tbody>
        </table>`;
    }
  },

  created() {
    this.website.encrypted_id = this.$route.params.website_id;

    this.$loading.show();
    getAll(this.website.encrypted_id, 'members_integrations_sale')
      .then(({data}) => {
        if (data.success) {
          this.emails.themes = data.data;
        }
      })
      .finally(() => this.$loading.hide());
  }
};
</script>

<style lang="scss">
.cke_top {
  border-bottom: 1px solid #DDE5ED !important;
  background: #F1F5F9 !important;
  padding: 6px 8px 2px !important;
  white-space: normal !important;
}

.cke_chrome {
  display: block !important;
  border: 1px solid #DDE5ED !important;
  border-radius: 6px !important;
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border: unset !important;
  border-top: 1px solid #0080FC !important;
  color: #0080FC !important;
  border-radius: 0 !important;
  background-color: #FFFF !important;

}

.nav-tabs {
  border-bottom: unset !important;
}

.nav-link {
  padding: .5rem .5rem !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  color: #425E7D99 !important;
  background-color: #F6F8FB !important;
  border-radius: 4px !important;
}

.nav-link:hover {
  color: #0080FC !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/EmailsIntegrations.vue